export default __webpack_public_path__ + "static/media/wblogo.f89b717e.svg";